<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>礼品类型管理</span>
          <span class="muted small" style="margin-left: 10px">维护礼品类型字典（供商品管理中礼品打标与分类联动使用）</span>
          <div style="float: right">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新建礼品类型</el-button>
          </div>
        </div>
      </template>

      <!-- 搜索/筛选 -->
      <el-form :inline="true" size="small" class="mb-3">
        <el-form-item label="类型名称">
          <el-input
            v-model="searchName"
            placeholder="输入名称搜索"
            clearable
            style="width: 180px"
            @keyup.enter.native="currentPage = 1"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchEnabled" placeholder="全部" clearable style="width: 120px">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="currentPage = 1">筛选</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="filteredTypes"
        stripe
        size="small"
        border
        v-loading="loading"
        @row-dblclick="row => openDialog(row)"
      >
        <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
        <el-table-column label="礼品类型名称" min-width="160">
          <template slot-scope="{ row }">
            <el-tag
              :color="row.color || '#E6A23C'"
              :style="(row.color ? 'color:#fff;border-color:' + row.color : 'color:#fff;border-color:#E6A23C')"
              size="small"
            >
              {{ row.name }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="对应客户身份称谓" min-width="160">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info">
              <i class="el-icon-user" style="margin-right: 4px;"></i>{{ row.customerCategoryName || (row.name ? row.name.replace(/礼品$/, '客户') : '-') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="颜色标识" width="130" align="center">
          <template slot-scope="{ row }">
            <span
              v-if="row.color"
              :style="'display:inline-block;width:16px;height:16px;border-radius:3px;background:' + row.color + ';vertical-align:middle;margin-right:6px'"
            ></span>
            <span class="muted">{{ row.color || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.enabled"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="onStatusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="备注说明" prop="remark" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openDialog(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新建 / 编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑礼品类型' : '新建礼品类型'"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" size="small">
        <el-form-item label="礼品类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入类型名称，如：普通礼品、大使礼品、直播兑换等" maxlength="50" @input="onNameInput"></el-input>
        </el-form-item>
        <el-form-item label="对应客户身份称谓" prop="customerCategoryName">
          <el-input v-model="form.customerCategoryName" placeholder="如：大使客户、普通客户（用于礼品名单客户身份管理）" maxlength="50">
            <el-button slot="append" @click="autoFillCustomerName">自动填充</el-button>
          </el-input>
          <div class="muted small" style="margin-top: 4px; line-height: 1.4;">在礼品名单中为客户分配客户身份时显示的称呼。留空将自动根据名称以“XX客户”填充</div>
        </el-form-item>
        <el-form-item label="标签颜色">
          <div style="display: flex; align-items: center">
            <el-color-picker v-model="form.color" :predefine="predefineColors"></el-color-picker>
            <span class="muted small" style="margin-left: 12px">用于在商品列表及下拉标签中标识该类型颜色</span>
          </div>
        </el-form-item>
        <el-form-item label="显示排序">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width: 160px"></el-input-number>
          <span class="muted small" style="margin-left: 10px">数值越小越靠前</span>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            maxlength="255"
            show-word-limit
            placeholder="请输入备注说明（如：常规活动伴手礼、高档VIP专享、直播间兑换券等业务范围）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">确定保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'GiftType',
  data() {
    return {
      typeList: [],
      loading: false,
      dialogVisible: false,
      submitting: false,
      searchName: '',
      searchEnabled: null,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入礼品类型名称', trigger: 'blur' }]
      },
      predefineColors: [
        '#409EFF',
        '#E6A23C',
        '#67C23A',
        '#F56C6C',
        '#909399',
        '#9B59B6',
        '#3498DB',
        '#1ABC9C',
        '#E74C3C',
        '#34495E'
      ]
    }
  },
  computed: {
    filteredTypes() {
      return this.typeList.filter(item => {
        const matchName = !this.searchName || (item.name && item.name.toLowerCase().includes(this.searchName.trim().toLowerCase()))
        const matchEnabled = this.searchEnabled === null || this.searchEnabled === '' || item.enabled === this.searchEnabled
        return matchName && matchEnabled
      })
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        name: '',
        color: '#E6A23C',
        sort: 0,
        enabled: 1,
        customerCategoryName: '',
        remark: ''
      }
    },
    loadList() {
      this.loading = true
      axios.get('/gift-type/list')
        .then(res => {
          this.typeList = Array.isArray(res.data) ? res.data : []
        })
        .catch(err => {
          this.$message.error('加载礼品类型列表失败：' + (err.message || '网络错误'))
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetSearch() {
      this.searchName = ''
      this.searchEnabled = null
    },
    openDialog(row) {
      if (row) {
        this.form = { ...row }
      } else {
        this.form = this.emptyForm()
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    onStatusChange(row) {
      const isEnabled = row.enabled === 1
      const actionText = isEnabled ? '启用' : '停用'
      axios.put(`/gift-type/${row.id}/status`, null, { params: { enabled: row.enabled } })
        .then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(`已${actionText}「${row.name}」`)
          } else {
            this.$message.error((res.data && res.data.message) || '状态更新失败')
            row.enabled = isEnabled ? 0 : 1
          }
        })
        .catch(err => {
          this.$message.error('操作失败：' + (err.message || '网络错误'))
          row.enabled = isEnabled ? 0 : 1
        })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const isEdit = !!this.form.id
        const req = isEdit
          ? axios.put('/gift-type', this.form)
          : axios.post('/gift-type', this.form)

        req.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(isEdit ? '修改礼品类型成功' : '新增礼品类型成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '保存失败')
          }
        }).catch(err => {
          this.$message.error('请求失败：' + (err.message || '网络错误'))
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    onDelete(row) {
      this.$confirm(`确定删除礼品类型「${row.name}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      }).then(() => {
        axios.delete('/gift-type/' + row.id)
          .then(res => {
            if (res.data && res.data.success !== false) {
              this.$message.success('删除成功')
              this.loadList()
            } else {
              this.$message.error((res.data && res.data.message) || '删除失败')
            }
          })
          .catch(err => {
            this.$message.error('删除请求失败：' + (err.message || '网络错误'))
          })
      }).catch(() => {})
    },
    autoFillCustomerName() {
      if (this.form.name) {
        this.form.customerCategoryName = this.form.name.replace(/礼品$/, '客户')
      }
    },
    onNameInput(val) {
      if (!this.form.id && (!this.form.customerCategoryName || this.form.customerCategoryName === this.lastAutoName)) {
        this.form.customerCategoryName = (val || '').replace(/礼品$/, '客户')
        this.lastAutoName = this.form.customerCategoryName
      }
    },
    formatDate(v) {
      return v ? String(v).replace('T', ' ').slice(0, 19) : '-'
    }
  }
}
</script>

<style scoped>
.muted {
  color: #909399;
}
.small {
  font-size: 12px;
}
.mb-3 {
  margin-bottom: 14px;
}
</style>
